export enum FilterTypes {
  TextField = 1,
  Dropdown = 2,
  Combobox = 3,
  Datepicker = 4,
  Slider = 5,
}
